import { Grid, Typography, Box } from "@mui/material";
import CustomBox from "../Common/CustomBox";
import Card from "../Common/Card";
import FAQ from "../Common/FAQ";
import useCustomLogic from "../../../../Hooks/UseCustomLogic";
import LitigantBox from "../Common/LitigantBox";
import ProgressBarComponent from "../../../../components/ReusableComponents/ProgressBarComponent";
import BarChart from "../Common/WaitingAreaBarChart.js";
import { useState, useEffect } from "react";
import { LoaderComponent } from "../../../../components/Loader/LoaderComponent";

const faqsStatic = [
  {
    content: "How many designated waiting area(s) are there?",
    status: "No",
  },
  {
    content: "If none, is there seating available anywhere else in building? *",
    status: "Yes",
  },
  {
    content: (
      <i>
        <b>Are the following facilities available? *</b>
      </i>
    ),
  },
  {
    content: "Air-conditioning",
    status: "No",
  },
  {
    content: "Drinking Water",
    status: "Yes",
  },
  {
    content: "Dustbins",
    status: "Yes",
  },
  {
    content: "eCase Display",
    status: "No",
  },
];

export const WaitingArea = ({ dataState, dataDistrict, selectedDistrict }) => {
  const { theme, loader } = useCustomLogic();
  let isDistrict = selectedDistrict === "Select District";

  const [faqs, setFaqs] = useState(faqsStatic);
  const [waitingAreaPresent, setWaitingAreaPresent] = useState("");
  const [progress, setProgress] = useState([]);
  const [barChart, setBarChart] = useState([]);
  const [barKey, setBarKey] = useState(1);

  useEffect(() => {
    setProgress([dataState?.percent, dataState?.waiting, dataState?.total]);
    if (dataState && isDistrict) {
      setBarChart([
        Number(dataState?.seats),
        Number(dataState?.fans),
        Number(dataState?.lighting),
        Number(dataState?.clean),
        Number(dataState?.access),
        Number(dataState?.other),
      ]);
    } else if (dataState) {
      setBarChart([
        Number(dataDistrict?.more_seats ?? dataDistrict?.seats ?? 0),
        Number(dataDistrict?.fan_ac ?? dataDistrict?.fans ?? 0),
        Number(dataDistrict?.better_lighting ?? dataDistrict?.lighting ?? 0),
        Number(dataDistrict?.better_clean ?? dataDistrict?.clean ?? 0),
        Number(dataDistrict?.diffently_abled ?? dataDistrict?.access ?? 0),
        Number(dataDistrict?.waiting_other ?? dataDistrict?.other ?? 0),
        // Number(dataDistrict?.litigant_survey?.more_seats),
        // Number(dataDistrict?.litigant_survey?.fans_ac),
        // Number(dataDistrict?.litigant_survey?.better_lighting),
        // Number(dataDistrict?.litigant_survey?.better_clean),
        // Number(dataDistrict?.litigant_survey?.access ?? 0),
        // Number(dataDistrict?.litigant_survey?.other ?? 0),
      ]);
    } else {
      setBarChart([]);
    }

    // District tab data
    if (dataDistrict && Object?.keys(dataDistrict).length > 0) {
      const designatedWaitingAreas = Number(dataDistrict?.designated_waiting_areas_count);
      const waitingArea =
        dataDistrict?.waiting_areas_present ??
        (Number.isFinite(designatedWaitingAreas) && designatedWaitingAreas > 0 ? "Yes" : "No");
      setWaitingAreaPresent(waitingArea);

      let arr = [
        dataDistrict?.designated_waiting_areas_count,
        dataDistrict?.alternate_seating_available,
        dataDistrict?.air_conditioning_available,
        dataDistrict?.drinking_water_available,
        dataDistrict?.dustbins_available,
        dataDistrict?.ecase_display_available,
      ];

      const index = 2;
      const newArr = [...arr?.slice(0, index), "", ...arr?.slice(index)];

      setFaqs(faqsStatic?.map((item, index) => ({ ...item, status: newArr[index] })));
    }

    setBarKey(Math.random());
  }, [dataState, dataDistrict, selectedDistrict]);

  return (
    <>
      {loader ? (
        <LoaderComponent height="50vh" />
      ) : (
        <Box>
          {isDistrict && (
            <>
              <Typography variant="regular3" color="secondary.main">
                Are there well-equipped waiting areas?
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mt: "10px",
                  textAlign: "left",
                  letterSpacing: "0.2px",
                  wordSpacing: "1px",
                }}
              >
                Litigants and lawyers need designated waiting areas while waiting for cases to be
                called up. Litigants were asked for their suggestions for improvements required to
                the waiting area.
              </Typography>
            </>
          )}

          <CustomBox
            content={isDistrict ? "AVAILABILITY OF WAITING AREAS:" : "Are there waiting areas?"}
            style={{
              fontSize: !isDistrict && "24px",
              padding: !isDistrict && "8px 13px",
              color: !isDistrict && theme.palette.common.black,
              backgroundColor: !isDistrict && "#e6ebf4",
            }}
            status={!isDistrict && waitingAreaPresent}
          />
          {isDistrict ? (
            <Grid container>
              <Grid item md={8} xs={12} sm={12} lg={8}>
                <ProgressBarComponent Percentage={progress[0] || 0} />
              </Grid>
              <Grid item md={4} xs={12} sm={12} lg={4}>
                <Typography sx={{ margin: "9px 7px" }}>
                  {progress[1] || 0} out of {progress[2] || 0} courts
                </Typography>
              </Grid>
            </Grid>
          ) : (
            <>
              {faqs &&
                faqs.map((elem, index) => {
                  return (
                    <FAQ
                      key={index}
                      content={elem?.content}
                      status={elem?.status}
                      isLastItem={index === faqs.length - 1}
                    />
                  );
                })}

              <Typography
                variant="body1"
                color={theme.palette.jaldi.gray}
                sx={{ margin: "30px 0px 15px 0px" }}
              >
                *This factor was not taken into consideration for scoring.
              </Typography>
            </>
          )}

          <LitigantBox mt={!isDistrict && "26px"} mb={!isDistrict && "0px"} />

          <CustomBox
            mt={!isDistrict && "0px"}
            mb="20px"
            content="HOW CAN WAITING AREAS BE MADE MORE COMFORTABLE?"
          />

          <BarChart key={barKey} data={barChart} />

          {/* <>
        <CustomBox content="Are there waiting areas?" status="No" />

        {cardData.map((item, index) => {
          return index === 2 ? (
            <FAQ
              content={item.content}
              style={{ color: "black", fontStyle: "italic" }}
            />
          ) : (
            <FAQ content={item.content} status={item.status} />
          );
        })}
      </>
      )
} */}
        </Box>
      )}
    </>
  );
};
